import React from 'react';
import classNames from 'classnames';

import i18n from '@/settings/i18n';
import * as styles from './CsvUploadButton.module.scss';

type Props = {
  children?: never;
  isUploading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const CsvUploadButton: React.FC<Props> = ({ isUploading, onChange }) => (
  <label
    htmlFor="csvUpload"
    className={classNames(styles.root, isUploading && styles.disabled)}
  >
    <span className={styles.innerText}>
      {i18n.t('text.user.index.csvUpload')}
    </span>
    <input
      type="file"
      id="csvUpload"
      onChange={onChange}
      disabled={isUploading}
      className={styles.hidden}
    />
  </label>
);
